import { render, staticRenderFns } from "./spinner-status-label.vue?vue&type=template&id=a892b82e&"
import script from "./spinner-status-label.vue?vue&type=script&lang=js&"
export * from "./spinner-status-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports